import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import SnackbarComponent from "../SnackbarComponent"; 

const useStyles = makeStyles(() => ({
  card: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "10px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    maxWidth: "500px",
    margin: "0 auto",
    transition: "transform 0.3s ease !important",
    "&:hover": {
      transform: "translateY(-6px)",
    },
  },
  liked: {
    color: "red", 
  },
}));

const Blog = ({ blog }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(blog.likes);
  const [snackbarOpen, setSnackbarOpen] = useState(false); 

  useEffect(() => {
    const storedLiked = localStorage.getItem(`blog_${blog.id}_liked`);
    const storedLikeCount = localStorage.getItem(`blog_${blog.id}_likeCount`);

    if (storedLiked) {
      setLiked(storedLiked === "true");
    }
    if (storedLikeCount) {
      setLikeCount(parseInt(storedLikeCount));
    }
  }, [blog.id]);

  const handleLike = () => {
    const newLiked = !liked;
    const newLikeCount = newLiked ? likeCount + 1 : likeCount - 1;

    setLiked(newLiked);
    setLikeCount(newLikeCount);

    localStorage.setItem(`blog_${blog.id}_liked`, newLiked);
    localStorage.setItem(`blog_${blog.id}_likeCount`, newLikeCount);
  };

  const handleReadMore = () => {
    navigate(blog.readMoreLink);
  };

  const handleShare = () => {
    const url = window.location.href;
    navigator.clipboard.writeText(url).then(() => {
        setSnackbarOpen(true);  
    });
  };

  const handleSnackbarClose = () => {
  setSnackbarOpen(false); 
  };

  return (
    <Card className={classes.card}>
      <CardHeader title={blog.title} subheader={blog.date} />
      <CardMedia
        component="img"
        image={blog.image}
        alt={blog.title}
        sx={{
          height: {
            xs: 160,
            sm: 240,
          },
        }}
      />
      <CardContent>
        <Typography variant="body2" sx={{ color: "black" }}>
          {blog.description}
        </Typography>
      </CardContent>
      <CardActions disableSpacing sx={{ display: "flex", alignItems: "center" }}>
        <IconButton aria-label="add to favorites" onClick={handleLike}>
          <FavoriteIcon className={liked ? classes.liked : ""} /> {/* Apply liked style */}
          <Typography variant="caption" sx={{ ml: 0.5 }}>
            {likeCount}
          </Typography>
        </IconButton>
        <IconButton onClick={handleShare} aria-label="share">
          <ShareIcon />
        </IconButton>
        <Box sx={{ flexGrow: 1 }} />
        <Button
          variant="outlined"
          size="small"
          sx={{
            color: "black",
            borderColor: "black",
            "&:hover": {
              borderColor: "black",
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
          onClick={handleReadMore}
        >
          Read More
        </Button>
      </CardActions>
      <SnackbarComponent
        open={snackbarOpen}
        message="Link copied to clipboard!"
        onClose={handleSnackbarClose}
      />
    </Card>
  );
};

export default Blog;